(function () {
  // Redirections SEO/UX (mono-produit) :
  // - /products      → /              (listing brut inutile, 1 produit)
  // - /search        → /              (pas de moteur de recherche utile)
  // - /blogs         → /              (pas de contenu blog actif)
  // - /collections   → /collections/all (la page liste-collections est vide,
  //                                       on envoie sur la collection unique)
  //
  // /collections/* (sauf /collections seul) et /products/handle restent ACCESSIBLES :
  // - Les fiches produit ont des avis Judge.me et du contenu SEO
  // - Les boutons "Ajouter au panier" sont neutralisés via CSS + main-product.liquid CTA
  //   → impossible de bypasser le questionnaire pour acheter.
  var p = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
  if (p === '/products' || p === '/search' || p.indexOf('/blogs') === 0) {
    location.replace('/');
    return;
  }
  if (p === '/collections') {
    location.replace('/collections/all');
  }
})();
